(() => {
  // --------------------------------------------------------
  // 共通
  // --------------------------------------------------------

  // Lenisの初期化
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: 'vertical', 
    gestureDirection: 'vertical',
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: false,
    touchMultiplier: 2,
    infinite: false,
  });

  // アンカーリンクのスムーススクロール
  $(document).on('click', 'a[href^="#"]', function(e) {
    e.preventDefault();
    const target = document.querySelector($(this).attr('href'));
    if(target) {
      // ウィンドウ幅に応じてヘッダー高さを設定
      const headerOffset = window.innerWidth <= 768 ? '8rem' : '10rem';
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - parseFloat(headerOffset) * parseFloat(getComputedStyle(document.documentElement).fontSize);
      lenis.scrollTo(targetPosition);
    }
  });

  // アニメーションループ
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  const excludeEles = document.querySelectorAll('.js-scrollable-element');
  excludeEles.forEach(excludeEle => {
    excludeEle.addEventListener('wheel',(e)=>{
      e.stopPropagation();
    })
  });

  // 年齢確認ダイアログ機能
  function initAgeConfirm() {
    const AGE_CONFIRM_KEY = 'ageConfirmed';
    const AGE_CONFIRM_TIMESTAMP_KEY = 'ageConfirmedTimestamp';
    const $confirm = $('.js-confirm');
    const EXPIRE_HOURS = 1; // 1時間後に再表示
    
    // ローカルストレージで年齢確認済みかチェック
    const confirmedTimestamp = localStorage.getItem(AGE_CONFIRM_TIMESTAMP_KEY);
    const isConfirmed = localStorage.getItem(AGE_CONFIRM_KEY) === 'true';
    
    if (isConfirmed && confirmedTimestamp) {
      const now = new Date().getTime();
      const confirmedTime = parseInt(confirmedTimestamp);
      const expireTime = confirmedTime + (EXPIRE_HOURS * 60 * 60 * 1000);
      
      // まだ有効期限内の場合
      if (now < expireTime) {
        $confirm.hide();
        return;
      } else {
        // 有効期限切れの場合、データを削除
        localStorage.removeItem(AGE_CONFIRM_KEY);
        localStorage.removeItem(AGE_CONFIRM_TIMESTAMP_KEY);
      }
    }
    
    // 確認ダイアログを表示
    $confirm.fadeIn(500);
    
    // ダイアログ表示中はスクロールを停止
    lenis.stop();
    
    // 「はい」ボタンのクリックイベント
    $confirm.find('button').eq(0).on('click', function() {
      // ローカルストレージに確認済みを保存（タイムスタンプ付き）
      localStorage.setItem(AGE_CONFIRM_KEY, 'true');
      localStorage.setItem(AGE_CONFIRM_TIMESTAMP_KEY, new Date().getTime().toString());
      // ダイアログを非表示
      $confirm.fadeOut(500, function() {
        // フェードアウト完了後にスクロールを再開
        lenis.start();
      });
    });
    
    // 「いいえ」ボタンのクリックイベント
    $confirm.find('button').eq(1).on('click', function() {
      // 前のページに戻る（スクロール再開は不要）
      history.back();
    });
  }

  $('.js-accordion').on('click', function(){
    $(this).toggleClass('is-active');
    $(this).next().slideToggle();
  });

  $('.js-drawer-trigger').on('click', function(){
    $('html').toggleClass('is-drawer-open');
    
    // ドロワーが開いているかチェック
    if($('html').hasClass('is-drawer-open')) {
      // ドロワーが開いた時はLenisのスクロールを停止
      lenis.stop();
    } else {
      // ドロワーが閉じた時はLenisのスクロールを再開
      lenis.start();
    }
  });
  
  if($('.p-top').length == 0) {
    // ページ読み込み時に年齢確認を初期化
    initAgeConfirm();
  }

  // --------------------------------------------------------
  // トップページ JS
  // --------------------------------------------------------

  if($('.p-top').length <= 1) {

    // videoタグの自動再生機能
    function initVideoAutoPlay() {
      const videoElements = document.querySelectorAll('.js-movie');
      
      if (videoElements.length === 0) return;

      // Intersection Observer のオプション
      const observerOptions = {
        root: null, // ビューポートをルートとする
        rootMargin: '0px',
        threshold: 0.1 // 10%が表示されたら発火
      };

      // Intersection Observer のコールバック関数
      const observerCallback = (entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          
          if (entry.isIntersecting) {
            // 表示領域に入った時の処理
            video.currentTime = 0; // 最初から再生
            video.play().catch(error => {
              console.log('Video autoplay failed:', error);
            });
          } else {
            // 表示領域から出た時の処理
            video.pause();
          }
        });
      };

      // Observer を作成
      const observer = new IntersectionObserver(observerCallback, observerOptions);

      // 各videoタグを監視対象に追加
      videoElements.forEach(video => {
        observer.observe(video);
      });
    }

    // videoタグの自動再生機能を初期化
    initVideoAutoPlay();
    
    // GSAPタイムライン作成
    const tl = gsap.timeline();
    
    var innerHeight = window.innerHeight;
    //wrapは任意の値に変えてください。
    $('html').css('--innerHeight', innerHeight + 'px');

    // タイムラインにアニメーションを追加
    tl.to(".js-body", 1, {
      opacity: 1,
    })
    
    if($('.p-top').length > 0) {
      tl.fromTo(".js-catch path", 1, {
        opacity: 0,
        x: 10,
        y: 10,
      }, {
        opacity: 1,
        x: 0,
        y: 0,
        stagger: 0.05,
      }, '-=0.3')
      
      tl.fromTo(".js-calligraphy", 1, {
        opacity: 0,
      }, {
        opacity: 1,
      }, '-=0.3')
      
      tl.fromTo(".js-product", 1, {
        opacity: 0,
      }, {
        opacity: 1,
      }, '<')
      
      tl.fromTo(".js-header", 1, {
        opacity: 0,
      }, {
        opacity: 1,
      }, '-=0.5').then(() => {
        // タイムラインが完了したら実行される関数
        initAgeConfirm();
      })
    }
  }

  // --------------------------------------------------------
  // 〆 トップページ JS
  // --------------------------------------------------------

  const productDetailSwiperEl = document.querySelector('.js-product-detial-swiper');
  if(productDetailSwiperEl){
    productDetailSwiper(productDetailSwiperEl);
  }
})();

document.addEventListener('DOMContentLoaded',()=>{
  const relatedSwiperEls = document.querySelectorAll('.js-related-swiper');
  if(relatedSwiperEls.length){
    relatedSwiper(relatedSwiperEls);
  }
})

// 商品詳細ページのSwiper実装
function productDetailSwiper(swiperEl) {
  const paginationEl = document.querySelector('.js-product-detial-swiper__pagination');
  new Swiper(swiperEl,{
    pagination: {
      el: paginationEl,
      type: 'bullets',
      renderBullet: (index, className) => {
        const slide = swiperEl.querySelectorAll('.swiper-slide')[index];
        const img = slide?.querySelector('img')?.getAttribute('src') || '';
        return `<button type="button" class="${className}" aria-label="Go to slide ${index + 1}">
                  <img src="${img}" alt="">
                </button>`;
      },
      clickable: true
    }
  })
}

// 関連商品などをスマホのみでSwiper実装
function relatedSwiper(relatedSwiperEls) {
  console.log(relatedSwiperEls)
  relatedSwiperEls.forEach(item => {
    new Swiper(item,{
    })
  })
}

// Alpine
document.addEventListener('alpine:init',() => {
  // デバイス判定
  Alpine.store("device", {
    isMobile: window.innerWidth <= 768,
  });

  window.addEventListener("resize", () => {
    Alpine.store("device").isMobile = window.innerWidth <= 768;
  });
})